module.exports = __webpack_public_path__ + "static/media/Logo1.6a3a744a.svg";